import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

// Hourly bikes-available bars for the micromobility site detail page. The
// occupancy action returns null for hours with no samples; those render as
// gaps, never as zero-height bars, because "no data" and "no bikes" differ.
export default class MicromobilitySiteChartController extends Controller {
  static targets = ['canvas', 'status', 'chart']
  static values = { url: String }

  async connect () {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const data = await response.json()

      if (!data.any_data) {
        this.statusTarget.textContent = 'No availability history recorded for this station yet.'
        return
      }

      this.statusTarget.classList.add('hidden')
      this.chartTarget.classList.remove('hidden')
      this.chart = new Chart(this.canvasTarget, {
        type: 'bar',
        data: {
          labels: data.labels,
          datasets: [{
            label: 'Peak bikes available',
            data: data.values,
            backgroundColor: '#A9C0E1',
            borderRadius: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: { ticks: { maxTicksLimit: 8, maxRotation: 0 }, grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 }, title: { display: true, text: 'Bikes' } }
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                title: (items) => `${items[0].label} (${data.time_zone.replace('_', ' ')})`,
                label: (item) => (item.raw === null ? 'No data' : `${item.raw} ${item.raw === 1 ? 'bike' : 'bikes'} at peak`)
              }
            }
          }
        }
      })
    } catch {
      this.statusTarget.textContent = 'Could not load availability history.'
    }
  }

  disconnect () {
    if (this.chart) this.chart.destroy()
  }
}
